import React from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import PropTypes from 'prop-types'

function NavMobileHeader({ currentStep }) {
  return (
    <ListItem
      sx={({ palette }) => ({
        '&:before': {
          content: '" "',
          height: '36px',
          width: '4px',
          background: palette.common.brand,
        },
      })}
    >
      <ListItemIcon>
        {currentStep.progress === currentStep.maxProgress
          ? currentStep.checkedIcon
          : currentStep.icon}
      </ListItemIcon>
      <ListItemText primary={currentStep.label} />
    </ListItem>
  )
}

NavMobileHeader.propTypes = {
  currentStep: PropTypes.object,
}
NavMobileHeader.defaultProps = {
  currentStep: {},
}
export default NavMobileHeader
